<template>
  <section>
    <v-container fluid>
      <v-row justify-md="space-between">
        <v-col cols="12" md="auto">
          <v-btn @click="openFormDialog" class="accent shadow-4 px-8" color="success" large rounded>
            Añadir bot
          </v-btn>
        </v-col>
      </v-row>

      <!-- show-expand
          single-expand -->
      <br />

      <v-card class="shadow-1">
        <v-data-table
          :search="search"
          :headers="headers"
          :items="pricingsList"
          item-key="id"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="totalItems"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
        >
          <template v-slot:[`item.whatsapp`]="{ item }">
            <span> {{ item.whatsapp.name }} - {{ item.whatsapp.number }}</span>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip top color="blue-grey">
              <template v-slot:activator="{ on }">
                <v-hover v-slot:default="{ hover }">
                  <v-btn text icon v-on="on" :color="hover ? 'accent' : 'blue-grey'" @click.stop="openDetailsDialog2(item)">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </v-hover>
              </template>
              <span>Ver y editar opciones</span>
            </v-tooltip>

            <v-tooltip top color="blue-grey">
              <template v-slot:activator="{ on }">
                <v-hover v-slot:default="{ hover }">
                  <v-btn text icon v-on="on" :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleAdd(item)">
                    <v-icon>mdi-playlist-plus</v-icon>
                  </v-btn>
                </v-hover>
              </template>
              <span>Agregar opción</span>
            </v-tooltip>

            <v-tooltip top color="blue-grey">
              <template v-slot:activator="{ on }">
                <v-hover v-slot:default="{ hover }">
                  <v-btn text icon v-on="on" :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleEdit(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-hover>
              </template>
              <span>Editar bot</span>
            </v-tooltip>

            <v-tooltip top color="blue-grey">
              <template v-slot:activator="{ on }">
                <v-hover v-slot:default="{ hover }">
                  <v-btn text icon v-on="on" :color="hover ? 'error' : 'blue-grey'" @click.stop="handleDelete(item)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-hover>
              </template>
              <span>Eliminar bot</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>

      <newForm
        v-if="isOpenForm"
        :isActive="isOpenForm"
        :isEditMode="isEditMode"
        :dataToEdit="eventToEdit"
        @close:dialog="closeFormDialog"
      ></newForm>

      <newOptionForm
        v-if="isOpenOptionForm"
        :isActive="isOpenOptionForm"
        :parentId="optionData.bot_id || null"
        :parentName="optionParentName"
        :data="optionData"
        @close:dialog="closeOptionFormDialog"
      ></newOptionForm>

      <botDetails
        v-if="isOpenDetails"
        :isActive="isOpenDetails"
        :data="detailsData"
        @close:dialog="closeDetailsDialog"
      ></botDetails>
    </v-container>
    <show-details
      v-if="activeVTreeCrud"
      :isActive="activeVTreeCrud"
      :data="detailsData"
      @close:dialog="activeVTreeCrud = false"
    ></show-details>
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import newForm from "./newForm.vue";
import newOptionForm from "./newFormOptions.vue";
import botDetails from "./showDetails.vue";
import ShowDetails from "./showDetails.vue";

export default {
  components: {
    newForm,
    newOptionForm,
    botDetails,
    ShowDetails,
  },

  data: () => ({
    isLoading: false,
    isOpenDetails: false,
    activeVTreeCrud: false,
    isOpenForm: false,
    isOptionEditMode: false,
    isOpenOptionForm: false,
    isEditMode: false,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    pricingsList: [],
    eventToEdit: {},
    optionData: {},
    optionParentName: "",
    detailsData: {},
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "left",
        value: "name",
        class: "primary--text",
        width: "30%",
      },
      {
        text: "Linea Whatsapp",
        align: "left",
        value: "whatsapp",
        class: "primary--text",
        width: "30%",
      },
      {
        text: "Creado",
        align: "left",
        value: "created_at",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "20%",
        align: "center",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getBotsList();
      },
      deep: true,
    },
  },

  created() {
    this.getTrunks();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    openOptionFormDialog() {
      this.isOpenOptionForm = true;
    },

    openDetailsDialog(item) {
      this.detailsData = item;
      this.isOpenDetails = true;
    },

    openDetailsDialog2(item) {
      this.detailsData = item;
      this.activeVTreeCrud = true;
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.eventToEdit = item;
      this.openFormDialog();
    },

    handleAdd(item) {
      this.isOptionEditMode = true;
      this.optionData = {
        queue_id: item.closing_queue,
        bot_id: item.id,
      };
      this.optionParentName = item.name;
      this.openOptionFormDialog();
    },

    async handleDelete(event) {
      // const accessToken = localStorage.getItem("token");

      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este bot? Ésta acción no es reversible.`,
        );
        if (confirmRequest.isConfirmed) {
          PbxHttpClient.delete(`/whatsapps/bot/${event.id}`)
            .then((res) => {
              const index = this.pricingsList.findIndex((el) => el.id === res.data.bot_id);
              this.pricingsList.splice(index, 1);

              this.$snotify.success("Bot eliminado", "¡Hecho!");
            })
            .catch(() => {
              // console.error(error);
              this.$snotify.error("Hubo un error al eliminar.", "Error");
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar el bot.", "¡Error!");
        // console.error(error);
      }
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode) this.pricingsList = this.pricingsList.map((el) => (el.id === data.id ? data : el));
      if (data && !this.isEditMode) this.pricingsList = [...this.pricingsList, data];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.eventToEdit = {};
    },

    closeOptionFormDialog() {
      // if (data && this.isEditMode)
      //   this.pricingsList = this.pricingsList.map((el) =>
      //     el.id === data.id ? data : el
      //   );
      // if (data && !this.isEditMode)
      //   this.pricingsList = [...this.pricingsList, data];

      this.getBotsList();
      this.isOpenOptionForm = false;
      this.optionData = {};
      this.optionParentName = "";
    },

    closeDetailsDialog() {
      // this.getBotsList();
      this.activeVTreeCrud = false;
      this.isOpenDetails = false;
      this.detailsData = {};
    },

    async getBotsList() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/whatsapps/bot`, {
        params: { page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.pricingsList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
